import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { thunk } from 'redux-thunk';
import authReducer from "./Auth/reducer";
import purchaseReducer from "./Purchase/reducer";
import salesReducer from "./Sales/reducer";
import loadReducer from "./Load/reducer";
import commonReducer from "./Common/reducer";
import bookingReducer from "./Booking/reducer";
import addressReducer from "./Address/reducer";
import ratequoteReducer from "./RateQuote/reducer";
import importRateQuoteReducer from "./ImportRateQuote/reducer";
import loaderReducer from "./Loader/reducer";

import vesselReducer from "./Masters/vessel/reducer";
import commodityReducer from "./Masters/commodity/reducer";
import clauseReducer from "./Masters/clause/reducer";
import countryClauseReducer from "./Masters/countryclause/reducer";
import chargesCodeReducer from "./ChargesCode/reducer"
import { toastReducer } from './Toast/reducer';
import PortPlaceReducer from "./Masters/PortPlace/reducer";
import locationReducer from "./Masters/location/reducer";
import ImportbookingReducer from "./ImportBooking/reducer";
import BookinRquestReducer from "./BookingRequest/reducer";


const rootReducer = combineReducers({
    auth: authReducer,
    purchase: purchaseReducer,
    sales: salesReducer,
    load: loadReducer,
    common: commonReducer,
    booking: bookingReducer,
    addressBook: addressReducer,
    rateQuote: ratequoteReducer,
    loader: loaderReducer,
    vessel: vesselReducer,
    commodity: commodityReducer,
    clause: clauseReducer,
    countryClause: countryClauseReducer,
    chargesCode: chargesCodeReducer,
    PortPlace: PortPlaceReducer,
    toast: toastReducer,
    locations: locationReducer,
    importRateQuoteReducer: importRateQuoteReducer,
    importBooking: ImportbookingReducer,
    bookinRquest: BookinRquestReducer,
});

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    rootReducer,
    composeEnhancers(
        applyMiddleware(thunk)
    )
);

// store.subscribe(() => {
//     console.log('Current store state:', store.getState());
// });

export default store;